import React, { useEffect } from "react";
import { SlArrowLeft } from "react-icons/sl";
import { Link, useParams } from "react-router-dom";
import { getEventById } from "../redux/eventSlice";
import { useDispatch, useSelector } from "react-redux";
import { Calendar, MapPin, Clock } from "lucide-react";
import { convertToNepaliDate } from "../components/FormatDate";

const EventDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { currentEvent, loading } = useSelector((state) => state.events);

  useEffect(() => {
    if (id) {
      dispatch(getEventById(id));
    }
  }, [id, dispatch]);

  console.log(currentEvent);

  return (
    <div className="bg-gray-200 min-h-screen">
      {/* Header */}
      <div className="flex justify-between bg-[#3F3F95] px-4 py-4 w-full rounded-b-2xl shadow-lg">
        <div className="items-center my-auto">
          <Link to="/userdash">
            <SlArrowLeft className="text-white text-xl hover:scale-110 transition-transform duration-200" />
          </Link>
        </div>
        <h1 className="font-bold flex justify-center flex-col mx-auto text-2xl text-white tracking-wide">
          Event Details
        </h1>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        {/* Event Title Card */}
        <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow duration-300">
          <h2 className="text-3xl capitalize font-bold text-gray-800 mb-1 leading-tight">
            {currentEvent?.name}
          </h2>
          <div className="h-1 w-20 bg-[#3F3F95] rounded-full mt-3"></div>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 gap-3">
          {/* Date Card */}
          <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
            <div className="flex items-center space-x-3">
              <div className="bg-[#3F3F95] bg-opacity-10 p-3 rounded-lg">
                <Calendar className="text-[#3F3F95] w-5 h-5" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Date</p>
                <p className="text-lg font-semibold text-gray-800">{convertToNepaliDate(currentEvent?.date)}</p>
              </div>
            </div>
          </div>

          {/* Venue Card */}
          <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
            <div className="flex items-center space-x-3">
              <div className="bg-[#3F3F95] bg-opacity-10 p-3 rounded-lg">
                <MapPin className="text-[#3F3F95] w-5 h-5" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Venue</p>
                <p className="text-lg font-semibold text-gray-800">{currentEvent?.venue}</p>
              </div>
            </div>
          </div>

          {/* Time Card */}
          <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
            <div className="flex items-center space-x-3">
              <div className="bg-[#3F3F95] bg-opacity-10 p-3 rounded-lg">
                <Clock className="text-[#3F3F95] w-5 h-5" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Time</p>
                <p className="text-lg font-semibold text-gray-800">{currentEvent?.time}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Description Card */}
        <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow duration-300">
          <h3 className="text-lg font-bold text-gray-800 mb-3">About This Event</h3>
          <p className="text-base text-gray-700 leading-relaxed whitespace-pre-line">
            {currentEvent?.description}
          </p>
        </div>

        {/* Image Card */}
        {currentEvent?.file?.original_url && (
          <div className="bg-white rounded-2xl p-4 shadow-md hover:shadow-xl transition-shadow duration-300">
            <h3 className="text-lg font-bold text-gray-800 mb-3">Event Image</h3>
            <div className="relative overflow-hidden rounded-xl">
              <img
                src={currentEvent?.file?.original_url}
                alt="Event"
                className="w-full h-auto object-cover rounded-xl hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDetail;